<template>
	<div :key="'test' + zone_geo" v-if="zone_geo && active_study.qlikData">
		<template v-if="showLastSection">
			<section-dynamique-territoriale-end />

			<!-- SECTION MARCHE PROMOTION IMMOBILIERE -->
			<div class="main-title">
				<p class="title dark_blue_text">
					<span class="no dark_blue_bg">{{ index }}</span>
					{{ selected_zone_geo_name }}
				</p>
			</div>
		</template>

		<div class="section" :class="main_color">
			<el-edit-mode :showChart="showChart_4_2" :theme="theme" @change="updateCharts()"
				@toggleShowChart="updateShowChart_4_2()" />

			<slot v-if="typeof app_parameters.default_components !== 'undefined'" :list_kpi="list_kpi" :table_prix_mcarre="table_prix_mcarre">
				<div>
					<div>
						<div class="part part-acquereurs-prix">
							<p v-if="!(list_kpi && list_kpi.error)" class="label main_color_text">
								<el-textarea :parent_data="list_kpi.title.parent_data"
									:property="list_kpi.title.property" :editable="true" :max-length="130" />
							</p>
							<!-- <p v-else class="label main_color_text">
                                <el-textarea
                                    :parent_data="active_study.etudeData.promotion"
                                    property="manual_periode_kpi"
                                    :editable="true"
                                />
                            </p> -->
							<div :class="{ 'can-change': editor.mode == 'editing' }">
								<!-- <el-keypoints /> -->
								<error v-if="list_kpi.error" relative />
								<div v-else class="tle-row condensed">
									<div class="tle-col one-third" v-for="(kpi, i) in list_kpi.table" :key="'kpi' + i">
										<el-square :parent_data="kpi.parent_data" :property="kpi.property"
											:suffix="kpi.unit" :label="kpi.header"
											:sub_value="{ value: { parent_data: kpi.sub.parent_data, property: kpi.sub.property }, suffix: kpi.sub.suffix }"
											:editable="false" format="string" />
									</div>
								</div>
							</div>
						</div>
					</div>

					<div class="tle-row">
						<div class="tle-col half">
							<div class="part part-volume-prix">
								<error v-if="chart_volume_prix.error" />
								<template v-else>
									<p class="label main_color_text">{{ chart_volume_prix.title[0].value }}</p>
									<el-promo-volume-prix :key="volume_prix_chart_key" :editable="false"
										:is_OIP="is_OIP" :is_non_obs="is_non_obs" :last_year_period="last_year_period"
										:data="chart_volume_prix" :zone_geo="zone_geo"
										:zone_geo_quartier="zone_geo_quartier" :zone_geo_secteur="zone_geo_secteur"
										:showChart=showChart_4_2 />
								</template>
							</div>
							<div class="q-mt-lg">
								<p class="label main_color_text">
									Durée moyenne de commercialisation
									<br />
									<span class="small"></span>
								</p>
								<!-- <el-bar-dash-chart :values="duree_commerciale" /> -->
								<error v-if="chart_duree_commercialisation.error" />
								<el-promo-duree-commercialisation v-else :editable="false" :is_OIP="is_OIP"
									:is_non_obs="is_non_obs" :last_year_period="last_year_period"
									:data="chart_duree_commercialisation" :zone_geo="zone_geo"
									:zone_geo_quartier="zone_geo_quartier" :zone_geo_secteur="zone_geo_secteur" />
								<br />
								<p class="source">(en offre de mois de stock)</p>
							</div>
							<div class="part part-volume-prix q-mt-lg">
								<p class="label main_color_text">
									Grille de prix des opérations de référence
								</p>
								<el-operations-reference
									:parent_data="active_study.etudeData.cartographie && active_study.etudeData.cartographie.references_prix ? active_study.etudeData.cartographie.references_prix : undefined"
									property="obs" :editable="true" />
							</div>
						</div>
						<div class="tle-col half">
							<p class="label main_color_text">Prix au m² (neuf {{ period_title }} - revente / 2021-2022)</p>
							<el-table :table="table_prix_mcarre" variant="tags" />
							<div class="q-mt-md">
								<p class="label main_color_text">Nature des acquéreurs</p>
								<div :class="{ 'can-change': editor.mode == 'editing' }">
									<el-table :table="table_nature_acquereurs" />
								</div>
							</div>
							<div class="promo_comment q-mt-md">
								<div class="comment">
									<el-textarea :parent_data="active_study.etudeData.promotion" property="commentaire"
										:editable="true" height='176px' overflow_edit='hidden scroll' />
								</div>
							</div>
						</div>
					</div>
				</div>
			</slot>
		</div>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import PageMixin from "@/components/study/editor/pages/page.mixin.js";
import SectionDynamiqueTerritorialeEnd from "@/components/study/editor/pages/sections/section-dynamique-territoriale-end";
import error from "@/components/global/error.vue";
import getParameter from "@/libs/get_parameter.js";
import number from "@/libs/number";

export default {
	name: "section-marche-promotion-immobiliere",
	mixins: [PageMixin],
	components: {
		SectionDynamiqueTerritorialeEnd,
		error,
	},
	data: function () {
		return {
			volume_prix_chart_key: 0,
			parking_value: 200,
			test_secteur: Object,
			showChart_4_2: true,
		};
	},
	props: {
		index: { default: 1 },
		main_color: { default: "dark_blue" },
		showLastSection: { default: true },
		theme: {
			type: String,
			required: true,
		},
		dynamiqueLogementQlikComponentId: {
			type: String,
			default: "3.2"
		},
		kpiQlikComponentId: {
			type: String,
			default: "4.1"
		},
		volumePrixQlikComponentId: {
			type: String,
			default: "4.2"
		},
		prixMCarreQlikComponentId: {
			type: String,
			default: "4.3"
		},
		dureeCommercialisationQlikComponentId: {
			type: String,
			default: "4.4"
		},
		natureAcquereursQlikComponentId: {
			type: String,
			default: "4.5"
		},
		dynamiqueLogementQlikComponentName: {
			type: String,
			default: "dynamique construction globale"
		},
		kpiQlikComponentName: {
			type: String,
			default: "volume activite"
		},
		volumePrixQlikComponentName: {
			type: String,
			default: "volumes et prix"
		},
		prixMCarreQlikComponentName: {
			type: String,
			default: "prix par metre carre"
		},
		dureeCommercialisationQlikComponentName: {
			type: String,
			default: "temps commercialisation moyen"
		},
		natureAcquereursQlikComponentName: {
			type: String,
			default: "nature acquereurs"
		},
	},
	computed: {
		...mapGetters(["active_study", "editor", "etude_data", "app_parameters"]),
		parameters () {
			return this.active_study.qlikData.parameters.editmode.find((editmode) => {
				return editmode.theme == this.theme;
			});
		},
		is_edit_mode: function () {
			const result = this.editor.mode == "editing";
			return result;
		},
		table_objectifs_plh: function () {
			const table = {
				head: [], body: [], config: {
					cols_width: [66, 34]
				}
			};
			const parent = this.active_study.etudeData.dynamique_territoriale;
			table.body.push([
				{ value: "Total lgts/an", },
				{ parent_data: parent, property: "total_logements_annuel", format: "number", editable: true }
			]);
			table.body.push([
				{ value: "dont locatif social" },
				{ parent_data: parent, property: "total_logements_locatif_social", format: "number", editable: true, }
			]);
			table.body.push([
				{ value: "dont PLS" },
				{ parent_data: parent, property: "total_logements_pls", format: "number", editable: true, }
			]);
			table.body.push([
				{ value: "dont locatif interm." },
				{ parent_data: parent, property: "total_logements_locatif_intermediaire", format: "number", editable: true, }
			]);

			return table;
		},
		dynamique_logements: function () {
			const dynamique = {};

			let component = this.active_study.qlikData.component.find((component) => {
				return component.id == this.dynamiqueLogementQlikComponentId || component.name == this.dynamiqueLogementQlikComponentName;
			});

			try {
				//todelete : switch mode error/nominal (false => error case)
				//component.valid = false;
				//throw "il y a une erreur"


				// if an error is detectd in back => set componenet from default_component
				if (component.valid == false) {
					//get error_message from component
					// dynamique.error_message="[BACK] : "+component.errorMessage;
					dynamique.error_message = "Donnée non disponible";
					//get defualt component
					component = this.app_parameters.default_components.find((component) => {
						return component.id == this.dynamiqueLogementQlikComponentId || component.name == this.dynamiqueLogementQlikComponentName;
					});
					dynamique.error = true;
				} else {
					dynamique.labels = component.content.epci.header.labels;
					dynamique.values = component.content.epci.header.values;
					dynamique.max = component.content.epci.header.max;
					dynamique.data = { "ratiologt_1000hab": component.content.epci.data.value };
					dynamique.editable = false;
				}
			} catch (error) {

				dynamique.labels = [];
				dynamique.values = [];
				dynamique.max = "13";
				dynamique.data = { "ratiologt_1000hab": "0" };

				dynamique.error = true;
				// dynamique.error_message="[FRONT] : Une erreur est survenue veuillez contacter un administrateur!  : "+error;
				dynamique.error_message = "Donnée non disponible";
			}

			return dynamique;
		},
		new_quartiers: function () {
			return this.active_study.qlikData.geo.quartiers;
		},
		new_secteurs: function () {
			return this.active_study.qlikData.geo.secteurs_adequation;
		},
		parametersGeo: function () {
			try {
				const parametersPromo = this.active_study.qlikData.parameters.editmode.find((editmode) => {
					return editmode.theme == "marche_promotion_immobiliere";
				});
				// console.log('parametersPromo.geo : ', parametersPromo.geo)

				return parametersPromo.geo;
			} catch (e) {
				return false;
			}
		},
		is_OIP () {
			// return this.etude_data.data_perimeter === "OIP";
			return this.active_study.qlikData.geo.perimetre_type.source.toUpperCase() == "OIP";
		},
		is_non_obs () {
			//let non_obs = this.etude_data.data_perimeter === "NON-OBS" || this.etude_data.data_perimeter === "-";
			const non_obs = this.active_study.qlikData.geo.perimetre_type.observation == false;
			return non_obs;
		},
		selected_zone_geo_name () {

			// switch (this.zone_geo) {
			// 	case "commune":
			// 		return "Marché de la promotion immobilière à " + this.active_study.qlikData.geo.commune.label;
			// 	case "epci":
			// 		return "Marché de la promotion immobilière dans l'agglomération " + this.active_study.qlikData.geo.epci.label;
			// 	case "quartier":
			// 		return "Marché de la promotion immobilière à " + this.active_study.qlikData.geo.commune.label + " - " + this.new_quartiers.find((quartier) => { return quartier.code == this.zone_geo_quartier; }).label;
			// 	case "secteurs_adequation":
			// 		return "Marché de la promotion immobilière à " + this.new_secteurs.find((secteur) => { return secteur.code == this.zone_geo_secteur; }).label;
			// 	default: return "";
			//}

			let prefix = "";
			let message = "";
			switch (this.zone_geo) {
			case "commune":
			case "quartier":
			case "secteurs_adequation":
				prefix = "Marché de la promotion immobilière à ";
				break;
			case "epci":
				prefix = "Marché de la promotion immobilière dans l'agglomération ";
				break;
			default:
				message = "";
				break;
			}

			try{
				switch (this.zone_geo) {
				case "commune":
					message = this.active_study.qlikData.geo.commune.label;
					break;
				case "epci":
					message = this.active_study.qlikData.geo.epci.label;
					break;
				case "quartier":
					message = this.active_study.qlikData.geo.commune.label + " - " + this.new_quartiers.find((quartier) => { return quartier.code == this.zone_geo_quartier; }).label;
					break;
				case "secteurs_adequation":
					message = this.new_secteurs.find((secteur) => { return secteur.code == this.zone_geo_secteur; }).label;
					break;
				default:
					message = "";
					break;
				}
			}catch(err){
				//console.log("selected_zone_geo_name : OUPS error during ")
			}
			//console.log("selected_zone_geo_name : OK ")
			return prefix + message;
		},
		zone_geo () {
			let defaultValue = null;

			if (this.parameters) {
				defaultValue = this.parameters.geo.default;
			}

			return this.getParameter("zoneGeo", defaultValue);
		},
		kpiQlikComponent () {
			return this.active_study.qlikData.component.find((component) => {
				return component.name == this.kpiQlikComponentName || component.id == this.kpiQlikComponentId;
			});
		},
		list_kpi () {
			try {
				if (this.kpiQlikComponent.errorMesage || !this.kpiQlikComponent.valid) {
					throw new Error(this.kpiQlikComponent.errorMesage);
				}

				let data;

				try {
					if (this.zone_geo == "quartier") {
						data = this.kpiQlikComponent.content["quartiers"].find(
							(item) =>
								item.code == this.getParameter("zoneGeoQuartier", 0) &&
								item.period == this.getParameter("lastYearPeriod", this.parameters.periods.values[0].code)
						);
					} else if (this.zone_geo == "commune") {
						data = this.kpiQlikComponent.content["commune"].find(
							(item) => item.period == this.getParameter("lastYearPeriod", this.parameters.periods.values[0].code)
						);
					} else if (this.zone_geo == "secteurs_adequation") {
						data = this.kpiQlikComponent.content["secteurs_adequation"].find(
							(item) =>
								item.code == this.getParameter("zoneGeoSecteur", 0) &&
								item.period == this.getParameter("lastYearPeriod", this.parameters.periods.values[0].code)
						);
					} else {
						data = this.kpiQlikComponent.content[this.zone_geo].find(
							(item) => item.period == this.getParameter("lastYearPeriod", this.parameters.periods.values[0].code)
						);
					}
				} catch (e) {
					console.warn(`Geo Data for theme:${this.theme} and zone:${this.zone_geo} are not resolved correctly.`, e);
				}
				const table = data.data_list.map(item => ({
					parent_data: item.values[0],
					property: "value",
					unit: item.values[0].unit,
					value: item.values[0].value + item.values[0].unit,
					header: item.label,
					sub: {
						parent_data: item.values[1],
						property: "value",
						suffix: item.values[1].unit
					},
					title: "Indicateurs clés"
				}));

				const titleParentData = this.kpiQlikComponent.title.find((title) => {
					return title.code == this.last_year_period;
				});
				return {
					table,
					title: {
						parent_data: titleParentData,
						property: "value"
					}
				};
			} catch (e) {
				return {
					error: e
				};
			}
		},
		quartier_data () {
			return this.etude_data.promotion.quartier_data;
		},
		secteur_data () {
			return this.etude_data.promotion.secteur_data;
		},
		last_year_period () {
			return this.getParameter("lastYearPeriod", this.parameters.periods.values[0].code);
		},
		chart_volume_prix: function () {
			try {
				const component = this.active_study.qlikData.component.find((component) => {
					return component.name == this.volumePrixQlikComponentName || component.id == this.volumePrixQlikComponentId;
				});
				return component;
			} catch (e) {
				return {
					error: true
				};
			}
		},
		chart_duree_commercialisation: function () {
			try {
				const component = this.active_study.qlikData.component.find((component) => {
					return component.name == this.dureeCommercialisationQlikComponentName || component.id == this.dureeCommercialisationQlikComponentId;
				});
				return component;
			} catch (e) {
				return {
					error: true
				};
			}
		},
		table_nature_acquereurs: function () {
			const table = {
				head: [],
				body: [],
				config: {
					cols_width: [34, 33, 33],
				},
			};
			try {
				let component = this.active_study.qlikData.component.find((component) => {
					return component.name == this.natureAcquereursQlikComponentName || component.id == this.natureAcquereursQlikComponentId;
				});
				table.head.push(["", "Investisseurs", "Occupants"]);

				//todelete : switch mode error/nominal (false => error case)
				//component.valid = true;
				//throw "il y a une erreur"

				// if an error is detectd in back => set componenet from default_component
				if (component.valid == false) {
					//get error_message from component
					// table.error_message="[BACK] : "+component.errorMessage;
					table.error_message = "Donnée non disponible";

					//get defualt component
					component = this.app_parameters.default_components.find((component) => {
						return component.name == this.natureAcquereursQlikComponentName || component.id == this.natureAcquereursQlikComponentId;
					});
					table.error = true;

					const elem = component.content.epci;
					for (let i = 0; i < elem.header_list.length; i++) {
						table.body.push([elem.header_list[i].value, elem.data_list[i].investisseur.value + elem.data_list[i].investisseur.unit, elem.data_list[i].occupant.value + elem.data_list[i].occupant.unit]);
					}
				}
				//Nominal case
				else {

					if (this.zone_geo == "quartier") {
						if (this.zone_geo_quartier == undefined)
							return table;
						const quartier = component.content.quartiers.find((quartier) => {
							return quartier.code == this.zone_geo_quartier;
						});
						for (let i = 0; i < quartier.header_list.length; i++) {
							table.body.push([quartier.header_list[i].value, quartier.data_list[i].investisseur.value + quartier.data_list[i].investisseur.unit, quartier.data_list[i].occupant.value + quartier.data_list[i].occupant.unit]);
						}
					} else if (this.zone_geo == "secteurs_adequation") {
						if (component.content.secteurs_adequation) {
							const secteur = component.content.secteurs_adequation.find((secteur) => {
								return secteur.code == this.zone_geo_secteur;
							});
							for (let i = 0; i < secteur.header_list.length; i++) {
								table.body.push([secteur.header_list[i].value, secteur.data_list[i].investisseur.value + secteur.data_list[i].investisseur.unit, secteur.data_list[i].occupant.value + secteur.data_list[i].occupant.unit]);
							}
						}
					} else {
						const elem = component.content[this.zone_geo];
						for (let i = 0; i < elem.header_list.length; i++) {
							table.body.push([elem.header_list[i].value, elem.data_list[i].investisseur.value + elem.data_list[i].investisseur.unit, elem.data_list[i].occupant.value + elem.data_list[i].occupant.unit]);
						}
					}

					const trimestreMaj = this.parameters.periods.values.find((val) => {
						return val.code == this.last_year_period;
					});
					const liste_annee = trimestreMaj.periods.find((per) => {
						return per.component_id == "nature_acquereurs" || per.component_id == "4.5";
					}).values;

					table.body = table.body.filter((elem) => {
						const result = liste_annee.split(",").indexOf(elem[0]) > -1;
						return result;
					});


				}
			}
			// if an error occured in front => //display empty table with error message
			catch (error) {
				//get defualt component
				const component = this.app_parameters.default_components.find((component) => {
					return component.name == this.natureAcquereursQlikComponentName || component.id == this.natureAcquereursQlikComponentId;
				});

				table.error = true;
				// table.error_message= "[FRONT] : Une erreur est survenue veuillez contacter un administrateur!  : "+error;
				table.error_message = "Donnée non disponible";

				const header = component.content.epci.header_list.reduce((accu, curr) => {
					accu.push(curr.value);
					return accu;
				}, []);
				table.head.push(header);

				const elem = component.content.epci;
				for (let i = 0; i < elem.header_list.length; i++) {
					table.body.push([elem.header_list[i].value, elem.data_list[i].investisseur.value + elem.data_list[i].investisseur.unit, elem.data_list[i].occupant.value + elem.data_list[i].occupant.unit]);
				}
			}
			// add temp field
			table.body.forEach(function (item) {
				let elem = item[0];
				// supprimer '*'
				elem = elem.replace("*", "");
				// regarder que les 4 derniers char
				elem = elem.substring(elem.length - 4);
				item.push(elem);
			});
			// sort usint temp field
			table.body.sort((a, b) => a[3] > b[3] ? 1 : -1);
			//remove temp field
			table.body.forEach(function (item) {
				item.pop();
			});
			return table;
		},

		table_prix_mcarre () {
			const result = {
				head: [],
				body: [],
				config: {
					cols_width: [74, 26]
				}
			};

			try {
				let component = this.active_study.qlikData.component.find((component) => {
					return component.name == this.prixMCarreQlikComponentName || component.id == this.prixMCarreQlikComponentId;
				});

				//todelete : switch mode error/nominal (false => error case)
				//component.valid = true;
				//throw "il y a une erreur"

				// if an error is detectd in back => set componenet from default_component
				if (component.valid == false) {
					//get default component
					component = this.app_parameters.default_components.find((component) => {
						return component.name == this.prixMCarreQlikComponentName || component.id == this.prixMCarreQlikComponentId;
					});
					result.error = true;
					// result.error_message= "[BACK] : "+component.errorMessage;
					result.error_message = "Donnée non disponible";
				}

				let table = [];
				if (this.zone_geo == "quartier") {
					if (this.zone_geo_quartier == undefined) {
						return table;
					}

					const c = component.content.quartiers.find((quartier) => {
						return quartier.code == this.zone_geo_quartier && quartier.period == this.last_year_period;
					});
					// console.log('this.zone_geo_quartier : ',this.zone_geo_quartier);
					// console.log('this.last_year_period : ',this.last_year_period);
					// console.log('jna/quartier -  data_list : ',c.data_list);
					c.data_list.forEach((elem) => {
						elem.header = elem.label;
						//elem.value = elem.value ==="" ? "-" : elem.value
					});
					table = c.data_list;

				} else if (this.zone_geo == "secteurs_adequation") {
					const secteur = component.content.secteurs_adequation.find((secteur) => {
						return secteur.code == this.zone_geo_secteur && secteur.period == this.last_year_period;
					});

					//ci-dessous : correction qui ne fonctionne que de façon aléatoire!!
					secteur.data_list.forEach((elem) => {
						elem.header = elem.label;
						//elem.value = elem.value ==="" ? "-" : elem.value
					});
					table = secteur.data_list;
				} else {
					const c = component.content[this.zone_geo].find((period) => {
						return period.period == this.last_year_period;
					});
					c.data_list.forEach((elem) => {
						elem.header = elem.label;
						//elem.value = elem.value ==="" ? "-" : elem.value
					});
					table = c.data_list;

				}

				table.forEach((elem) => {
					result.body.push([
						{ value: elem.header },
						{
							parent_data: elem,
							property: "value",
							editable: elem.edit,
							suffix: " " + elem.unit,
							legend: elem.legend
						}
					]);
				});
			} catch (error) {
				//get default component
				let component;
				try {
					if (typeof this.app_parameters.default_components.find((component) => { return component.name == this.prixMCarreQlikComponentName || component.id == this.prixMCarreQlikComponentId; }) !== "undefined") {
						component = this.app_parameters.default_components.find((component) => {
							return component.name == this.prixMCarreQlikComponentName || component.id == this.prixMCarreQlikComponentId;
						});
					}
				} catch (e) {
					console.error(e);
				}
				result.error = true;
				//result.error_message= "[FRONT] : Une erreur est survenue veuillez contacter un administrateur!  : "+error;
				result.error_message = "Donnée non disponible";
				const table = [];
				component.content.epci[0].data_list.forEach((elem) => {
					table.push({
						value: elem.value === "" ? "-" : elem.value,
						unit: elem.unit,
						header: elem.label,
						rank: elem.rank,
						legend: elem.legend,
						edit: elem.edit
					});
				});
				table.forEach((elem) => {
					result.body.push([
						{ value: elem.header },
						{
							parent_data: elem,
							property: "value",
							editable: elem.edit,
							suffix: " " + elem.unit,
							legend: elem.legend
						}
					]);
				});
			}
			return result;
		},
		zone_geo_quartier () {
			return this.getParameter("zoneGeoQuartier", 0);
		},
		zone_geo_secteur () {
			return this.getParameter("zoneGeoSecteur", 0);
		},
		period_title () {
			const titleParentData = this.kpiQlikComponent.title.find((title) => {
				return title.code == this.last_year_period;
			});
			if(titleParentData && titleParentData.value){
				return "/" + titleParentData.value.split("/")[1];
			}
			return "";
		}
	},
	methods: {
		updateShowChart_4_2 () {
			this.showChart_4_2 = !this.showChart_4_2;
		},
		getParameter (name, defaultValue) {
			return getParameter(this.etude_data, this.theme, name, defaultValue);
		},
		updateCharts () {
			this.volume_prix_chart_key += 1;
		},
		value_text: function (value) {
			if (_.isUndefined(value)) {
				return "-";
			}
			let v = value;
			if (v != "-") {
				if (typeof v == "string") {
					v = v.replace(",", ".");
				}
				v = parseFloat(v);
				if (v > 100 || v == Math.trunc(v)) {
					v = parseInt(v);
				} else {
					v = v.toFixed(2);
				}
			}
			return v;
		},
		keep_last_years (yearly_dict, year_list) {
			// returns a dict of { year: values } for each year in year_list
			if (!yearly_dict) {
				console.error("inconsistent dictionnary of years in ", yearly_dict);
				return yearly_dict;
			}
			if (!year_list) {
				console.error("keep_last_years - missing parameter year_list");
			}
			const desired_years = year_list.split(",");
			return _.pick(yearly_dict, desired_years);
		},
		init_etude_nature_acquereurs_OIP (annual_data) {
			const result = [];
			// fill etude_data
			for (const [year, v] of _.entries(annual_data)) {
				let investisseur = number.to_float(v.vente_nette_investisseur_pourcentage);
				let occupant = number.to_float(v.vente_nette_occupant_pourcentage);
				if (isNaN(investisseur)) {
					investisseur = "-";
					occupant = "-";
				} else {
					if (investisseur) investisseur = this.$options.filters.percent(investisseur);
					if (occupant) occupant = this.$options.filters.percent(occupant);
				}
				const yearly_result = {
					year: year,
					investisseur: investisseur,
					occupant: occupant,
				};
				result.push(yearly_result);
			}
			this.$store.commit("EDIT_OBJECT", {
				obj: this.etude_data.promotion,
				field: "manual_nature_acquereurs",
				value: result,
			});
		},
		get_table_nature_acquereurs_manual (table, annual_data) {
			if (_.isEmpty(this.etude_data.promotion.manual_nature_acquereurs)) {
				this.init_etude_nature_acquereurs_OIP(annual_data);
			}
			// for (const [index, v] of _.entries(this.etude_data.promotion.manual_nature_acquereurs)) {
			for (let index = 0; index < this.etude_data.promotion.manual_nature_acquereurs; index++) {
				table.body.push([
					{
						parent_data: this.etude_data.promotion.manual_nature_acquereurs[index],
						property: "year",
						format: "string",
						editable: "true",
					},
					{
						parent_data: this.etude_data.promotion.manual_nature_acquereurs[index],
						property: "investisseur",
						format: "number",
						editable: "true",
					},
					{
						parent_data: this.etude_data.promotion.manual_nature_acquereurs[index],
						property: "occupant",
						format: "number",
						editable: "true",
					},
				]);
			}
			return table;
		},
	},
	watch: {
		showChart_4_2: function (to) {
			this.$store.commit("EDIT_OBJECT", {
				obj: this.etude_data.promotion,
				field: "compo_4_2_showChart",
				value: to,
			});
			this.$store.dispatch("save_study");
			//console.log("watch : "+to);
		}
	},
	created () {
		if (typeof (this.etude_data.promotion.compo_4_2_showChart) === "undefined") {
			this.showChart_4_2 = true;
		}
		else {
			this.showChart_4_2 = this.etude_data.promotion.compo_4_2_showChart;
		}
		//console.log(this.showChart_4_2);
	},
	mounted () {
	},
};
</script>

<style lang="stylus" scoped>
@import '../../../../../assets/css/app'
@import '../../../../../assets/css/page'

.error-container
    display flex
    justify-content center
    align-items center
    z-index: 20000
    position absolute
    top 0
    left 0
    width 100% !important
    height 101% !important
    text-align center
    border-style solid
    border-width 2px

.edit-error
	opacity 0.8
	background-color black
	color red
	border-color red

.read-error
	opacity 1
	background-color white
	color #3e5d58
	border-color #3e5d58

input[type='radio']
    vertical-align baseline
    padding 4px
    margin 4px
    color lighten(purple, 85%)

input[type='radio'] + label
    margin-left 4px

label
    display inline-block
    text-transform uppercase
    font-size 10px
    font-weight 500

input[type='range']
    display inline-block
    width 75%

.value
    float right
    width 25%
    padding 0 0 0 8px
    font-weight 500
    text-align center
    white-space nowrap

#quartier_selector
    width 220px
</style>
